<template>
    <div class="project-page" v-if="load">
        <div class="project-page-image">
            <div class="overlay">
                <navbar />
                <h2 class="main-title">{{data.name}}</h2>
            </div>
        </div>
        <div class="project-page-content container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-6 img">
                            <img v-if="data.images[0] != null" :src="data.images[0]" :alt="data.name"/>
                        </div>
                        <div class="col-lg-6 img">
                            <img v-if="data.images[1] != null" :src="data.images[1]" :alt="data.name"/>
                        </div>
                    </div>
                    <div class="row" style="margin-top: 20px">
                        <div class="col-lg-12 img">
                            <img v-if="data.images[2] != null" :src="data.images[2]" :alt="data.name"/>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 img">
                    <img v-if="data.images[3] != null" :src="data.images[3]" :alt="data.name"/>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-9">
                    <div class="details">
                        <h4 class="title">
                            {{ data.title }}
                        </h4>
                        <p class="disc">
                            {{ data.text }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="row button-row">
                <a :href="data.web_link" target="__blank" v-if="data.web_link != null">
                    <button class="visit-button">Visit Site</button>
                </a>
                <a :href="data.app_link" target="__blank" v-if="data.app_link != null">
                    <button class="visit-button">Download App</button>
                </a>
            </div>
        </div>
        <custom-footer />
    </div>
    <loader3 v-else />
</template>

<script>
import Navbar from "@/components/Navbar.vue"
import CustomFooter from "@/components/CustomFooter.vue"
import Loader3 from "@/components/Loader3.vue"

export default {
    name: "project-page",
    components: {
        Navbar,
        CustomFooter,
        Loader3
    },
    data() {
        return {
            data: null,
            load: false,
            project_id: null
        };
    },
    methods: {
        getData() {
            this.lang = localStorage.getItem("lang");
            this.axios.get(this.$store.state.url + "project_details?language=" + this.lang + "&project_id=" + this.project_id)
                .then(res => {
                    if (res.data.error == 'false') {
                        this.load = true
                        this.data = res.data.data
                    }
                    else
                        this.$router.replace({ name: '404-page' })
                    console.log(res.data.data)
                });
        },
    },
    mounted() {
        document.documentElement.scrollTop = 0;
        this.project_id = this.$route.params.id
        this.getData()
    }
};
</script>

<style lang="scss">
.project-page {
    position: absolute;
    z-index: 100;
}

.project-page .project-page-content {
    padding: 30px 50px;
    z-index: -1;
    position: relative;
}

.project-page .project-page-image {
    background-image: url(../assets/img/about-page.1.webp);
    position: relative;
    height: 60vh;
    background-position: 50%;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
    opacity: 90%;
}

.project-page .overlay {
    height: 100%;
    width: 100%;
    background: linear-gradient(270deg, #1268017c, #15203b96);
}

.project-page .project-page-image .main-title {
    text-align: center;
    font-weight: bold;
    color: #fff;
    margin-bottom: 60px;

}


@media (min-width: 992px) {
    .project-page .project-page-image .main-title {
        font-size: 50px;
        padding-top: 70px;
    }
}

@media (max-width: 991px) {
    .project-page .project-page-image .main-title {
        font-size: 40px;
        padding-top: 100px;
    }
}

.project-page .img {
    // background: #f4f4f4;
    display: flex;
    align-items: center;

}

.project-page img {
    width: 100%;
    height: 100%;
    border-radius: 15px;
}


.project-page .row {
    row-gap: 20px;
    // column-gap: 20px;
}

.project-page .details {
    text-align: justify;
    margin-top: 50px;
}

.project-page .title {
    color: var(--main-blue);
    font-weight: bold;
    margin: 60px 0 20px;
}

.project-page .disc {
    color: #666;
    font-size: 18px;
}

.project-page .logo-card {
    border: none;
    box-shadow: 0 0 20px rgb(0 0 0 / 17%);
    align-items: center;
    width: 420px;
    height: 250px;
    padding: 35px;
    border-radius: 20px;
}

.project-page .visit-button {
    position: relative;
    color: var(--main-blue);
    font-size: 16px;
    // font-weight: 800;
    text-decoration: none;
    margin: 30px 0;
    border: 1px solid var(--main-blue);
    padding: 12px 30px;
    overflow: hidden;
    transition: .6s all ease;
    background: transparent;
    border-radius: 10px;
    z-index: 10000;
}

.project-page .visit-button::before {
    background: var(--main-blue);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all .6s ease;
}

.project-page .visit-button:hover {
    color: #fff;
}

.project-page .visit-button::before {
    width: 0%;
    height: 102%;
}

.project-page .visit-button:hover::before {
    width: 102%;
}
.project-page .button-row{
    text-align: justify;
    margin-top: 20px;
    column-gap: 20px;
}
html:lang(en) .project-page .button-row{
    margin-left: 5px;
}
html:lang(ar) .project-page .button-row{
    margin-right: 5px;
}
</style>
